import { gql, useApolloClient, useMutation, useQuery } from "@apollo/client";
import React, { useState } from "react";
import ReactAudioPlayer from "react-audio-player";
import { Helmet } from "react-helmet-async";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Episode } from "../../components/episode";
import { SmallButton } from "../../components/small-button";
import { EPISODE_FRAGMENT, PODCAST_FRAGMENT } from "../../fragments";
import { timeSince } from "../../util/utility";
import { deleteEpisode, deleteEpisodeVariables } from "../../__generated__/deleteEpisode";
import { getEpisodeQuery, getEpisodeQueryVariables } from "../../__generated__/getEpisodeQuery";
import { MY_PODCAST_QUERY } from "./my-podcast";

export const MY_EPISODE_QUERY = gql`
  query getEpisodeQuery ($input: EpisodesSearchInput!) {
    getEpisode (input: $input) {
      ok
      error
      episode {
        ...EpisodeParts,
      }
    }
  }
  ${EPISODE_FRAGMENT}
`;


const DELETE_EPISODE_MUTATION = gql`
  mutation deleteEpisode($input: EpisodesSearchInput!) {
    deleteEpisode(input: $input) {
      error
      ok
      episodeId
      podcastId
    }
  }
`;

export const MyEpisode = () => {
    const history = useHistory();
    const client = useApolloClient();
    let { id } = useParams();
    const location = useLocation();
    id = Number(id);

    const [uploading, setUploading] = useState(false);

    const { data, loading } = useQuery<
        getEpisodeQuery,
        getEpisodeQueryVariables
    >(MY_EPISODE_QUERY, {
        variables: {
            input: {
                podcastId: Number(location.state.podcast.id),
                episodeId: Number(location.state.id),
            },
        },
    });

    console.log(location);

    const onCompleted = (d: deleteEpisode) => {
        const {
            deleteEpisode: { ok, episodeId, podcastId },
        } = d;
        if (ok) {
            alert("Episode Deleted!");
            setUploading(false);
            const queryResult = client.readQuery({
                query: MY_PODCAST_QUERY,
                variables: {
                    input: {
                        id: Number(podcastId),
                    },
                },
            });
            const deletedList = queryResult.myPodcast.podcast.episodes.filter((episode) => episode.id !== episodeId);

            client.writeQuery({
                query: MY_PODCAST_QUERY,
                variables: {
                    input: {
                        id: Number(podcastId),
                    },
                },
                data: {
                    myPodcast: {
                        ...queryResult.myPodcast,
                        podcast: {
                            ...queryResult.myPodcast.podcast,
                            episodes: deletedList
                        },
                    },
                },
            });
            history.goBack();
        }
    };

    const [deleteEpisodeMutation, { }] = useMutation<
        deleteEpisode,
        deleteEpisodeVariables
    >(DELETE_EPISODE_MUTATION, {
        onCompleted
    });

    const onDelete = async () => {
        try {
            setUploading(true);
            deleteEpisodeMutation({
                variables: {
                    input: {
                        podcastId: Number(location.state.podcast.id),
                        episodeId: Number(location.state.id),
                    },
                },
            });
        } catch (e) { }
    };

    return (
        <div className="pb-96">
            <Helmet>
                <title>Episode | KUDOK</title>
            </Helmet>
            <div className="bg-gray-800 w-full py-10 flex bg-no-repeat bg-cover" style={{ backgroundImage: `url(${'/images/podcast.jpeg'})` }}>
                <div className="flex flex-col text-white p-5 bg-gradient-to-r from-black">
                    <div className="flex flex-row m-5">
                        <div className="flex flex-col">
                            <h3 className="text-5xl">{data?.getEpisode.episode.title}</h3>
                            <span className="py-2 text-xs border-gray-400">
                                {timeSince(data?.getEpisode.episode.createdAt)}
                            </span>
                        </div>
                    </div>
                    <div className="p-5">
                        {data?.getEpisode.episode.description}
                    </div>
                    <div className="flex flex-row m-5">
                        <ReactAudioPlayer
                            src={data?.getEpisode.episode?.episodeVideo}
                            autoPlay
                            controls
                        />
                    </div>
                    <div className="flex flex-row">
                        <SmallButton style="ml-5" actionText="Edit Episode" onClick={() => {
                            history.push({
                                pathname: '/edit-episode',
                                state: { episode: data?.getEpisode.episode }
                            })
                        }} />
                        <SmallButton style="ml-5" loading={false} actionText="Delete Episode" onClick={() => onDelete()} />
                    </div>
                </div>
            </div>
        </div>
    );
};